import React from 'react';
import { GST_TYPES } from '../utils/constants';
import { Building2, FileText, Receipt, CheckCircle2 } from 'lucide-react';

const GSTTypeSelection = ({ selectedType, onChange, isPreview }) => {
    if (isPreview) return null;

    // Configuration for the cards matching the reference design
    const typeConfig = {
        [GST_TYPES.COMPOSITION]: {
            icon: Building2,
            description: "For composition dealers (Tax not collected)",
            badge: "Composition",
            badgeColor: "bg-blue-100 text-blue-700",
            borderColor: "border-slate-200",
            activeBorder: "border-blue-500",
            activeBg: "bg-blue-50"
        },
        [GST_TYPES.REGULAR]: {
            icon: FileText,
            description: "Standard GST registration (Tax collected)",
            badge: "Regular",
            badgeColor: "bg-green-100 text-green-700",
            borderColor: "border-slate-200",
            activeBorder: "border-blue-500",
            activeBg: "bg-blue-50"
        },
        [GST_TYPES.UNREGISTERED]: {
            icon: Receipt,
            description: "For businesses not registered under GST",
            badge: "Unregistered",
            badgeColor: "bg-slate-100 text-slate-700",
            borderColor: "border-slate-200",
            activeBorder: "border-blue-500",
            activeBg: "bg-blue-50"
        }
    };

    return (
        <div className="w-full mb-2">
            <div className="flex items-center gap-2 mb-4">
                <FileText className="text-blue-900" size={20} />
                <h2 className="text-lg font-bold text-slate-800">GST Type Selection</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {Object.values(GST_TYPES).map((type) => {
                    const config = typeConfig[type] || {};
                    const Icon = config.icon || FileText;
                    const isSelected = selectedType === type;

                    return (
                        <label
                            key={type}
                            className={`
                                relative flex flex-col p-4 rounded-xl border-2 transition-all duration-200 cursor-pointer select-none
                                ${isSelected
                                    ? `${config.activeBg} ${config.activeBorder} shadow-sm`
                                    : `bg-white ${config.borderColor} hover:border-slate-300 hover:bg-slate-50`
                                }
                            `}
                        >
                            <input
                                type="radio"
                                name="gstType"
                                value={type}
                                checked={isSelected}
                                onChange={(e) => onChange(e.target.value)}
                                className="absolute opacity-0 w-0 h-0"
                            />

                            <div className="flex items-start gap-4">
                                <div className={`p-2 rounded-lg ${isSelected ? 'bg-white' : 'bg-slate-100'}`}>
                                    <Icon size={20} className={isSelected ? 'text-blue-600' : 'text-slate-500'} />
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        {isSelected ? (
                                            <div className="w-4 h-4 rounded-full border-[5px] border-blue-600 bg-white"></div>
                                        ) : (
                                            <div className="w-4 h-4 rounded-full border-2 border-slate-300"></div>
                                        )}
                                        <span className={`font-bold text-sm ${isSelected ? 'text-blue-900' : 'text-slate-700'}`}>
                                            {type}
                                        </span>
                                    </div>

                                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide ${config.badgeColor}`}>
                                        {config.badge}
                                    </span>
                                </div>
                            </div>
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

export default GSTTypeSelection;
